import { Routes } from '@angular/router';
import { titleFormatter } from '@core/utils/general.utils';

export const organizationRoutes: Routes = [
  {
    path: 'organizations',
    title: titleFormatter('Organizations'),
    data: { title: 'Organizations' },
    loadComponent: () => import('./pages/Home/Home.component').then((m) => m.HomeComponent),
  },
];
